// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../channels2022/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lang-dropdown[data-v-618573d5]{width:450px;max-width:100%}.text-base[data-v-618573d5]{color:#7e7f88}.btn-custom-link.active[data-v-618573d5]{pointer-events:none;background-color:#f5f5f6}.ui-dark .btn-custom-link.active[data-v-618573d5]{background-color:#151727}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
